import { Stack, Button } from "@mui/material";
import { styles } from "../pages/styles";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import SubmitButton from "./SubmitButton";
interface Props {
  title: string;
  onClick(): void;
  btnWidth?: string
}

function ButtonPrimary({ title, onClick, btnWidth }: Props) {
  const handleSubmit = async () => {
    try {
      onClick();
      return true
    } catch {
      return false
    } 
  };
  return (
    <Stack direction="row" sx={{ alignItems: "center", justifyContent: "center", m: 4, width: btnWidth ?? "unset" }}>
      <SubmitButton
        onSubmit={handleSubmit}
        style={{
          ...styles.introSliderBtn,
          marginTop: "40px",
          width: btnWidth ?? 220,
        }}
        size={"large"}
        variant="contained"
        endIcon={<ArrowForwardIosIcon />}
        validate={async () => true}
      >
        <span style={{ paddingRight: 20, paddingLeft: 20, width: "100%" }}>{title}</span>
      </SubmitButton>
    </Stack>
  );
}

export default ButtonPrimary;
